import React, { useState, useEffect } from 'react';
import KBList from "./KBList.js";
import { colorWhite, mobileButton } from "../App/theme.js";
import { Box, Container, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Add, InstallMobile } from '@mui/icons-material';
import { getQueryParamValue, isMobile } from "../App/utils";
import { RecommendedApps } from "./RecommendedApps";

import Divider from '@mui/material/Divider';
import { KBName } from "../names";

export const KBListPage = ({ hideIfEmpty }) => {
    const [myKBs, setMyKBs] = useState(null);
    const [sharedWithMeKBs, setSharedWithMeKBs] = useState(null);
    const navigate = useNavigate();

    const onSuccessMyKBs = (data) => {
        setMyKBs(data);
    };

    const onSuccessSharedWithMe = (data) => {
        setSharedWithMeKBs(data);
    };

    useEffect(() => {
        if (myKBs?.length === 0 && sharedWithMeKBs?.length === 0) {
            navigate('/app-center');
        }
    }, [myKBs, sharedWithMeKBs, navigate]);

    return (
        <>
            {!isMobile && <Container>
                <Box mt={4} display="flex" style={{ marginBottom: '32px' }} justifyContent="flex-end">
                    <Button
                        style={mobileButton}
                        component={Link}
                        to="/app-center"
                        variant="contained"
                        color="secondary"
                        startIcon={<InstallMobile style={{ color: colorWhite }} />}
                    >
                        Install {KBName}
                    </Button>
                </Box>
            </Container>}

            {getQueryParamValue('recommend') && <>
                <Divider style={{ paddingBottom: 15 }}> Recommended Apps </Divider>
                <Box>
                    <RecommendedApps />
                </Box>
            </>}

            <KBList hideIfEmpty={true} onSuccess={onSuccessMyKBs} />

            <KBList hideIfEmpty={hideIfEmpty} onSuccess={onSuccessSharedWithMe} sharedWithMe={true} />
        </>
    );
};